
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqnkKNuu6OCUHNN2tzu4lc_45Rz9uDVyC7Ato2urq3BOMSsMeta } from "/codebuild/output/src1055913772/src/src/pages/faq.vue?macro=true";
import { default as menu_4575DxaZ_fmwhyl_KzW9N1jraBAnCCuXyZ44TQcTpigIMeta } from "/codebuild/output/src1055913772/src/src/pages/menu.vue?macro=true";
import { default as index4MqbM0kl4aBM5zZItcApSaSI5oEfbzI3jzeLWaBNRP8Meta } from "/codebuild/output/src1055913772/src/src/pages/index.vue?macro=true";
import { default as contactohWKdtq8SBhA8bjrinUdZFpMciIAz_45vLccYOuLd6OrAMeta } from "/codebuild/output/src1055913772/src/src/pages/contact.vue?macro=true";
import { default as tutorialS7HWoru9dkVbOYTn_45gl4J6Fx5_SahwtINwyKNV229ekMeta } from "/codebuild/output/src1055913772/src/src/pages/tutorial.vue?macro=true";
import { default as agreementD8QiuD5VrN74t8BJOpeJuRmMFwkBdaiAr8V2a_45Ze5SMMeta } from "/codebuild/output/src1055913772/src/src/pages/agreement.vue?macro=true";
import { default as about_45passIuGlq_45_WunylVsvqktVfyeKoPFvRS_45wDHqd5L_J8pmoMeta } from "/codebuild/output/src1055913772/src/src/pages/about-pass.vue?macro=true";
import { default as indexpGT332VEScviV4411QWDVYKohm_45szE_NCcPNQGPH3rMMeta } from "/codebuild/output/src1055913772/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93JuKoo12IvaAvw56cwGLcdLYPa0gf0h6TY2jovRmCM4gMeta } from "/codebuild/output/src1055913772/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceYtKIDmGyscj_KySB6RyWzzVi0eYSch971elnSGa8KOAMeta } from "/codebuild/output/src1055913772/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_931Iu0qTb_45DjQpb85K02xqnxam6JcW72QqGvv2W0dLYyMMeta } from "/codebuild/output/src1055913772/src/src/pages/notice/[id].vue?macro=true";
import { default as indexuwUAclhGPg_MX80xVe_45s4PM8qWpkLwnx6_xqPgUFbu4Meta } from "/codebuild/output/src1055913772/src/src/pages/coupon/index.vue?macro=true";
import { default as indexDCYA1l6kBL44S6Bn6Vcd5xkNJambMCZkubw7abzssqkMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/index.vue?macro=true";
import { default as indexc_TSHz1vGTUVMur7oMRAJbQT8GsM9rWEBBLivNLOoboMeta } from "/codebuild/output/src1055913772/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_930S3aZ3lvZe1itVy7Ty8emdsgaT4ywPttn7ZXCA03P48Meta } from "/codebuild/output/src1055913772/src/src/pages/parking/[id].vue?macro=true";
import { default as index6W_45xZXQeuqo9HQiHNGX5AcsLbKBKhiqw53WtfIJLO_oMeta } from "/codebuild/output/src1055913772/src/src/pages/history/index.vue?macro=true";
import { default as indexu3HEzskr_45LSTfzp9J9F5UEy6dyTgJT0iNWpdeYuuRWMMeta } from "/codebuild/output/src1055913772/src/src/pages/monthly/index.vue?macro=true";
import { default as indexDR4cEoXinN_45p9ybYqymEJadqbUuRaDpZ7TPF6Ylu2ZMMeta } from "/codebuild/output/src1055913772/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexcoVKUs2hrY4BOXnp0gaTor02s2Q13Q9byfG0wBfhe9QMeta } from "/codebuild/output/src1055913772/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavikcZQnC8FOxUHRIqEWMC0TnvRilBxi8WBDYqdeN4xv7QMeta } from "/codebuild/output/src1055913772/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editGQriWR0hpYEfvJVtF5rs42Rk7lWONa427_mOj3Be75EMeta } from "/codebuild/output/src1055913772/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementZFmca9Oz62_45F5IqEyO7xAp3eXGftzjJ9GBK_CiDfG5QMeta } from "/codebuild/output/src1055913772/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexQblED0abtDG_oE1iXH6rb_tyqIx5sBtVDhfqL_45OZTlwMeta } from "/codebuild/output/src1055913772/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d2uxzsy4lLKCsYqyJtdQqEcpPMjGBmAe4_uZOm7QHRWAMeta } from "/codebuild/output/src1055913772/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmvhtbMCA_bqEpW_45hGq8xeg50o1ZUCFVc20EKIGgffKCAMeta } from "/codebuild/output/src1055913772/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexAC2CmE9xvAKMKoxBQ9aLlQ68ueUpfEhicTu16ohHQpYMeta } from "/codebuild/output/src1055913772/src/src/pages/card/create/index.vue?macro=true";
import { default as indexCsq4YBvgXLB1pdCD7qNHE0bQrOySZc1RElNswxfH0NEMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmz_vxpXbVPHel_45nxm8pqZQtq8G8COHkhkixtJHnDSudUMeta } from "/codebuild/output/src1055913772/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmUowK295QNYqmgjEX2nV8Sx2C7C8vOZEs5fy_7gxr3ewMeta } from "/codebuild/output/src1055913772/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete_db6D2yy6ZGYfvpaUgLMwwMHnLwF1O_45J_1CbuWzYhGMMeta } from "/codebuild/output/src1055913772/src/src/pages/membership/complete.vue?macro=true";
import { default as registera3eEEpW5P_9YrktqGKbzwwJv0EkAZcliGREAWl8y1GQMeta } from "/codebuild/output/src1055913772/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93ahwlrjcZ7EcwB6ZAwsJusMbprM1sv8EqOwkY8fES9LgMeta } from "/codebuild/output/src1055913772/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmTq9SmpcQGG31NuRKWng8ZFXB67dvldCN95vfB0NbekcMeta } from "/codebuild/output/src1055913772/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93J1TgJVzMA8UWEGmNUzh4c8QJKHZm_CPEqQI_45dKxWm_45cMeta } from "/codebuild/output/src1055913772/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexavfjhbs12V43h2fhBRkSxzZkGnXqJ3DNMMPFVxzxEU8Meta } from "/codebuild/output/src1055913772/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeqHkAX61bwIM7q_kHrCLQYiVG4yPkmVdQwNopXMSGdD0Meta } from "/codebuild/output/src1055913772/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codebnj1h8AvNTzRRMpqyATYZiOsV60Hll5xQcvQ3zuqh_MMeta } from "/codebuild/output/src1055913772/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeu5bHELjBKKoAzMG0crTLkdZ_gpw1eRjzRmw82wjlfA4Meta } from "/codebuild/output/src1055913772/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerSkPP26Ivl0b6xhRXlmuSYBZHPljK6HI6kbrLWMkRhk8Meta } from "/codebuild/output/src1055913772/src/src/pages/contact-form/register.vue?macro=true";
import { default as completevarMrZDaJhf0hz5Y5AtDq5uKSefNZZIzUc2COQGkrUAMeta } from "/codebuild/output/src1055913772/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexd26Ede61s14dI2KKsJxF_M_3ShfRGq98RLBQ0WGv7DUMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmocoT43avyeL8ZvXbpkik0TGYViHGiEMUr7inZmtkhwYMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeenjFJsPspiOVNvvNB_40Qo_45U75e35C5C9SRJTHInvooMeta } from "/codebuild/output/src1055913772/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexi5Xd5T0KzVVMtnYC7mKChNSWAzuEB5QPB93kBW0ohnAMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93qc0xmMqOLbsjXPOtG_oC6Pavbh8D8JwV9W9W4kWMezAMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completezLcCsfQROXXBKrG_45l0MByYIHYIFUg3cTVY_45jZubEcJwMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasCIEd2prqRNPw4OAWBqu7vEMslqjfbFr3eJ3gzLzyQRIMeta } from "/codebuild/output/src1055913772/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample_45aPBNKnHMHMK2IL2zT9i2YLmg4ttuK7X8eOUyE5umtcMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailVZFz_459d_PSpmA6pXoOT5PBWhWLywMAZCiShYm1WgvGIMeta } from "/codebuild/output/src1055913772/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmDPx6cnWDDSyXr7cWy_Jgjmgb5K84belRH1ok32qyGDcMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentN08z8r1_FPD9jtN5kIO_45dEbJfEvX2LJeyY9tNFbp40wMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmCQOQcakFBUMtzlA8RcZFHkKHpy7I_9zSbqsJV7H0s2AMeta } from "/codebuild/output/src1055913772/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatekPTUEQRQh5aV0iaCqSCg5BCwoCzBGzZkUoPPDEHdcTsMeta } from "/codebuild/output/src1055913772/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completePvciG6_O8nTQO_45BWbEIyokU1_45907Mj5aVp0MbLNqhDUMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code5vk61xOblBomk9XFNZu26zwtGDpv4twvtnIagA5eb2sMeta } from "/codebuild/output/src1055913772/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordeX6U_IX_0gHHyxGHNqDGzJxkCUJIuUCG8Qm6wMAX9BEMeta } from "/codebuild/output/src1055913772/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasxbSWXeBivrKE3LC5OhmwXhcoHmHWaOv0owBAFIVe7ZYMeta } from "/codebuild/output/src1055913772/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerJhHhh1LiYLQjzQY2zTQW5vy1EnnbM_pC6K3SCL5qzvsMeta } from "/codebuild/output/src1055913772/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code2LqEIQglZwHqU_45v1LtZkaUxdEPRSl61q7pQix0e7Y_450Meta } from "/codebuild/output/src1055913772/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexv0nywGpcHnzRzXpHEj2DF9x7H0JQzikfFz_45nFEISP8YMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexY3qrecx_45nXtKXNkALGO2K_NoooaskY4wUioH8G6uhIAMeta } from "/codebuild/output/src1055913772/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexZCI8ggRDnscojPcar9e_451zqOa7YDi6g4chBQh09eoOgMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as index3C1M94rxSxABXt6UHepGb2ZDAIOCjbFoYcqG_4539SS4AMeta } from "/codebuild/output/src1055913772/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateaKZCzBXoV2Ly5hEA23XxophexJFkltANcslcXfHkJ8IMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completefxNwfkDi4ju2JtH6vHskmBoRyWPgIX26bKFMra0fpv4Meta } from "/codebuild/output/src1055913772/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmId7PNqj4QwIEqRGE6pB_45pHjrfyfnZPyEiH5njb_45CxnwMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexXP_45wTW849dBfd2YoWgwdnMxJ9MyR3dtzwD_45jKdldbokMeta } from "/codebuild/output/src1055913772/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete9jBx4QtXjIPPcZPd3xqMtIOfe6KKcecjF_BtXctgQskMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateezPqgbFbDQmBAXMN32PMAld8fsRr9Hq6ShfQhQyoVe4Meta } from "/codebuild/output/src1055913772/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexWTC3pTJ7upyly0a2XJ7F_45zXYQMd4xUFjh_5TcqnXficMeta } from "/codebuild/output/src1055913772/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexl7pZoOt7XCA6_45ncrIiv_45skXkwhnmu3t5ucE54TYK1dQMeta } from "/codebuild/output/src1055913772/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeciC__ZRAd1md1p25UxJ8z9F0zDh9iVxQWVkuxAYjBtwMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexqF8pduHFvIBdi86Ui9g4sXY_J7eDGpvdI5OF_RhXYJQMeta } from "/codebuild/output/src1055913772/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeSQ8nl0etiH7NyDM7lD_45OYMwuYyHEnQc9No4fR_FyTZgMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexjjHqAz6NhMMg_Q2NXbF3Wn9WoEDF01LPJHj6b5c35G8Meta } from "/codebuild/output/src1055913772/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as index5s1D9V0lARvT1oj2Xn1fduK2_c2VuGu7_El7o_WRtfwMeta } from "/codebuild/output/src1055913772/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexBdHCgFdcljdbj8vbH8BV65YlaHGoqD1MgHoiUIoihY8Meta } from "/codebuild/output/src1055913772/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatee61cCUQlN3X54DxYHtE_45XGQ76XDqfQhZuuwwLe7fMcoMeta } from "/codebuild/output/src1055913772/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmmA1c_B_dXycxkHfMMxLFVUVKEouID_hsdkeg8JVD0N8Meta } from "/codebuild/output/src1055913772/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu_4575DxaZ_fmwhyl_KzW9N1jraBAnCCuXyZ44TQcTpigIMeta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(index4MqbM0kl4aBM5zZItcApSaSI5oEfbzI3jzeLWaBNRP8Meta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src1055913772/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexuwUAclhGPg_MX80xVe_45s4PM8qWpkLwnx6_xqPgUFbu4Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1055913772/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index6W_45xZXQeuqo9HQiHNGX5AcsLbKBKhiqw53WtfIJLO_oMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1055913772/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexDR4cEoXinN_45p9ybYqymEJadqbUuRaDpZ7TPF6Ylu2ZMMeta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexcoVKUs2hrY4BOXnp0gaTor02s2Q13Q9byfG0wBfhe9QMeta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexAC2CmE9xvAKMKoxBQ9aLlQ68ueUpfEhicTu16ohHQpYMeta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmz_vxpXbVPHel_45nxm8pqZQtq8G8COHkhkixtJHnDSudUMeta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmUowK295QNYqmgjEX2nV8Sx2C7C8vOZEs5fy_7gxr3ewMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1055913772/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete_db6D2yy6ZGYfvpaUgLMwwMHnLwF1O_45J_1CbuWzYhGMMeta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registera3eEEpW5P_9YrktqGKbzwwJv0EkAZcliGREAWl8y1GQMeta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmTq9SmpcQGG31NuRKWng8ZFXB67dvldCN95vfB0NbekcMeta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeqHkAX61bwIM7q_kHrCLQYiVG4yPkmVdQwNopXMSGdD0Meta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codebnj1h8AvNTzRRMpqyATYZiOsV60Hll5xQcvQ3zuqh_MMeta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeu5bHELjBKKoAzMG0crTLkdZ_gpw1eRjzRmw82wjlfA4Meta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerSkPP26Ivl0b6xhRXlmuSYBZHPljK6HI6kbrLWMkRhk8Meta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmocoT43avyeL8ZvXbpkik0TGYViHGiEMUr7inZmtkhwYMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeenjFJsPspiOVNvvNB_40Qo_45U75e35C5C9SRJTHInvooMeta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexi5Xd5T0KzVVMtnYC7mKChNSWAzuEB5QPB93kBW0ohnAMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completezLcCsfQROXXBKrG_45l0MByYIHYIFUg3cTVY_45jZubEcJwMeta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample_45aPBNKnHMHMK2IL2zT9i2YLmg4ttuK7X8eOUyE5umtcMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailVZFz_459d_PSpmA6pXoOT5PBWhWLywMAZCiShYm1WgvGIMeta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmDPx6cnWDDSyXr7cWy_Jgjmgb5K84belRH1ok32qyGDcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentN08z8r1_FPD9jtN5kIO_45dEbJfEvX2LJeyY9tNFbp40wMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmCQOQcakFBUMtzlA8RcZFHkKHpy7I_9zSbqsJV7H0s2AMeta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completePvciG6_O8nTQO_45BWbEIyokU1_45907Mj5aVp0MbLNqhDUMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code5vk61xOblBomk9XFNZu26zwtGDpv4twvtnIagA5eb2sMeta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordeX6U_IX_0gHHyxGHNqDGzJxkCUJIuUCG8Qm6wMAX9BEMeta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerJhHhh1LiYLQjzQY2zTQW5vy1EnnbM_pC6K3SCL5qzvsMeta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code2LqEIQglZwHqU_45v1LtZkaUxdEPRSl61q7pQix0e7Y_450Meta || {},
    component: () => import("/codebuild/output/src1055913772/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1055913772/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]